import { Typography } from "@material-tailwind/react";
import { TruckIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";

export default function AdminOdooWorkordersTab() {
  return (
    <div className="flex flex-col items-center justify-center p-12 text-center bg-gray-50 border border-dashed border-gray-300 rounded-lg my-6">
      <TruckIcon className="w-12 h-12 text-gray-400 mb-3" />
      <Typography variant="h6" className="text-gray-700">
        {t("admin:odoo.workorders.comingSoonTitle", "Champs d'intervention")}
      </Typography>
      <Typography variant="small" className="text-gray-500 max-w-md mt-1">
        {t("admin:odoo.workorders.comingSoonDescription", "La configuration des correspondances de champs pour les interventions (sale.order) sera disponible prochainement.")}
      </Typography>
    </div>
  );
}
